import { useEffect, useState } from "react";
import api from "../api";
import { Spinner } from "../components/Logo";
import { PageHeader, PathCard, EmptyState } from "../components/ui";
import { Search, BookOpen } from "lucide-react";

export default function Learning() {
  const [data, setData] = useState(null);
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("");
  const [level, setLevel] = useState("");

  const load = () => {
    const params = {};
    if (search) params.search = search;
    if (category) params.category = category;
    if (level) params.level = level;
    api.get("/learning/paths", { params }).then((r) => setData(r.data)).catch(() => {});
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [category, level]);
  useEffect(() => {
    const t = setTimeout(load, 300);
    return () => clearTimeout(t);
    /* eslint-disable-next-line */
  }, [search]);

  return (
    <div data-testid="learning-page">
      <PageHeader overline="Learning Gallery" title="Explore learning paths" desc="Structured, bite-sized cybersecurity tracks — from fundamentals to advanced offense and defense." />

      <div className="flex flex-col sm:flex-row gap-3 mb-6">
        <div className="relative flex-1">
          <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
          <input className="input pl-10" placeholder="Search paths..." value={search} onChange={(e) => setSearch(e.target.value)} data-testid="learning-search" />
        </div>
        <select className="input sm:w-48" value={category} onChange={(e) => setCategory(e.target.value)} data-testid="learning-category">
          <option value="">All categories</option>
          {data?.categories?.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
        <select className="input sm:w-44" value={level} onChange={(e) => setLevel(e.target.value)} data-testid="learning-level">
          <option value="">All levels</option>
          {["Beginner", "Intermediate", "Advanced", "Expert"].map((l) => <option key={l} value={l}>{l}</option>)}
        </select>
      </div>

      {!data ? <Spinner /> : data.paths.length === 0 ? (
        <EmptyState icon={BookOpen} title="No learning paths found" desc="Try adjusting your search or filters." />
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {data.paths.map((p) => <PathCard key={p.id} p={p} to={`/app/learning/${p.id}`} />)}
        </div>
      )}
    </div>
  );
}
